import settings from '@/settings'

const atualizarTaxa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/compras/taxas-servico/${data.id}/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const listarTaxas = (headers) => {
  return fetch(`${settings.apetrusApi}/compras/taxas-servico/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

const criarTaxa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/compras/taxas-servico/`, {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const relatorioRepasseTaxas = (headers, mes, ano) => {
  let url = `${settings.apetrusApi}/compras/relatorio-repasse-taxas/?`
  if (mes) url += `data_inativado__month=${mes}&`
  if (ano) url += `data_inativado__year=${ano}`
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

export default {
  criarTaxa,
  atualizarTaxa,
  listarTaxas,
  relatorioRepasseTaxas
}
